import { createSlice } from '@reduxjs/toolkit'
import { Buffer } from 'buffer'
// eslint-disable-next-line import/no-cycle
import {
  acceptFriend,
  addFriend,
  deleteFriend,
  deleteUser,
  deleteUserProfile,
  denyFriend,
  getAffinities,
  getFrequency,
  getFriendsNotifications,
  getProfileItem,
  getSearchParams,
  getSocialLinks,
  getSocialLinksCategories,
  getUser,
  getUserProfile,
  selectProfile,
  updateUserProfile,
  updateUserSettings,
  setLiveLocData
} from 'store'
import {
  ENGAGEMENT_TYPES,
  MODAL_SECTION,
  NotificationSections,
  PENDING,
  REJECTED,
  SUCCEEDED
} from 'utils/constants'

import {
  addBlogPreference,
  archiveRequest,
  blogPreferenceAllContacts,
  blogPreferenceAllUsers,
  connectionRequestSeenAll,
  getAdminNotifications,
  getBlockedRequest,
  getBlogPreference,
  getComments,
  getFileTest,
  getPingTest,
  getPosts,
  updateLastSeenOfPost,
  likeComment,
  likePost,
  sharePost,
  savePost,
  postComments,
  putComments,
  postMakeNotificationSeen,
  postMakeNotificationSeenAll,
  postPosts,
  postPostsSilent,
  addImagePosts,
  addImagePostsSilent,
  getImagePosts,
  putPosts,
  putPostsSilent,
  deletePosts,
  removeBlogPreference,
  setDataTest,
  subscribeToProfile,
  pinFriend,
  getPinnedFriends,
  removeFriendRequest,
  getEngagementItems,
  lastSeenEngagement,
  eventSeenAll,
  getSavedEvents,
  saveEvent,
  getCryptoBalance,
  getEventComments,
  postEventComment,
  putEventComment,
  likeEventComment,
  seenVideoLinkNotice,
  blogNotifsCount
} from './axios'

const initialState = {
  user: null,
  userProfile: null,
  selectedUserProfile: null,
  activeProfile: null,
  userSectionPage: [],
  notificationSectionPage: [],
  chatSectionPage: [],
  blockedRequest: [],
  blogPreference: [],
  isProfileChanged: false,
  isProfileActive: true,
  isProfileIncomplete: false,
  isChangesSaved: false,
  isSettingPage: false,
  isLocationOpen: false,
  isPictureUploaded: '',
  croppedPicture: '',
  cropFor: '',
  closeResetProfileModal: true,
  userEdited: [],
  friendsNotifications: [],
  searchAffinities: [],
  filters: [],
  userPosition: [],
  searchBar: {},
  notificationRequestProfiles: [],
  isOpenRightModal: false,
  isOpenLeftModal: false,
  isCloseModal: false,
  isProfileDeleted: false,
  isNotifViewing: false,
  isProfileSwitched: false,
  adminNotifRequest: null,
  profileItemId: '',
  profileItem: null,
  searchSocialLinks: [],
  searchSocialLinksCategories: [],
  adminNotifications: {},
  pingStatus: '',
  fileStatus: '',
  dataStatus: '',
  quoteStatus: '',
  serverName: '',
  testImage: [],
  dataQuote: '',
  pingTestRes: null,
  fileTestRes: null,
  dataTestRes: null,
  quoteTestRes: null,
  randomPos: null,
  askForLocationServices: true,
  frequency: [],
  liveLocationCoordinates: null,
  openPopupBlogs: false,
  chosenNotifBlog: [],
  posts: [],
  postsOption: [],
  newPostsOption: [],
  postsTypeStatus: '',
  onPostEditor: '',
  postPostsApiMsg: '',
  execAutoArchive: false,
  comments: [],
  commentsOption: [],
  blogParent: [],
  closePane: false,
  hideNotification: false,
  openChatModal: false,
  closeChatModal: false,
  sharingToFriends: false,
  blogLinkToBeCopied: '',
  hideChat: false,
  chosenFriends: [],
  msgInputForBlogSharing: '',
  hideDrawerAnimation: false,
  isBlogFormOpen: false,
  openBlogForm: false,
  closeAllDrawers: false,
  openFriendRequest: null,
  markerOpenBeforeLogin: false,
  postLastSeenData: [],
  engagementItems: [],
  selectedEngagementType: '',
  fromEngagementPanel: {},
  lastIdForPost: null,
  lastIdForComment: null,
  lastIdForEngagement: null,
  repostThisPostData: {},
  blogRepostData: [],
  blogRepostParent: [],
  savedEvents: [],
  openPopupEvents: false,
  saveEventErrorMsg: '',
  silentPostId: null,
  savedEventId: null,
  connReqData: [],
  cryptoBalance: [],
  openBlogLink: '',
  eventComments: [],
  eventCommentTree: [],
  getUserStatus: PENDING | SUCCEEDED | REJECTED,
  getUserProfileStatus: PENDING | SUCCEEDED | REJECTED,
  selectProfileStatus: PENDING | SUCCEEDED | REJECTED,
  getAffinitiesStatus: PENDING | SUCCEEDED | REJECTED,
  getSearchParamsStatus: PENDING | SUCCEEDED | REJECTED,
  updateUserSettingsStatus: PENDING | SUCCEEDED | REJECTED,
  deleteProfileStatus: PENDING | SUCCEEDED | REJECTED,
  updateUserProfileStatus: PENDING | SUCCEEDED | REJECTED,
  deleteUserStatus: PENDING | SUCCEEDED | REJECTED,
  deleteFriendStatus: PENDING | SUCCEEDED | REJECTED,
  addFriendStatus: PENDING | SUCCEEDED | REJECTED,
  getFriendsNotificationsStatus: PENDING | SUCCEEDED | REJECTED,
  acceptFriendStatus: PENDING | SUCCEEDED | REJECTED,
  denyFriendStatus: PENDING | SUCCEEDED | REJECTED,
  getAdminNotificationsStatus: PENDING | SUCCEEDED | REJECTED,
  getProfileItemStatus: PENDING | SUCCEEDED | REJECTED,
  postMakeNotificationSeenStatus: PENDING | SUCCEEDED | REJECTED,
  postMakeNotificationSeenAllStatus: PENDING | SUCCEEDED | REJECTED,
  connectionRequestSeenAllStatus: PENDING | SUCCEEDED | REJECTED,
  getSocialLinksStatus: PENDING | SUCCEEDED | REJECTED,
  getSocialLinksCategoriesStatus: PENDING | SUCCEEDED | REJECTED,
  getFrequencyStatus: PENDING | SUCCEEDED | REJECTED,
  setLiveLocDataStatus: PENDING | SUCCEEDED | REJECTED,
  getPingTestStatus: PENDING | SUCCEEDED | REJECTED,
  getFileTestStatus: PENDING | SUCCEEDED | REJECTED,
  setDataTestStatus: PENDING | SUCCEEDED | REJECTED,
  archiveRequestStatus: PENDING | SUCCEEDED | REJECTED,
  getBlockedRequestStatus: PENDING | SUCCEEDED | REJECTED,
  getPostsStatus: PENDING | SUCCEEDED | REJECTED,
  updateLastSeenOfPostStatus: PENDING | SUCCEEDED | REJECTED,
  getCommentsStatus: PENDING | SUCCEEDED | REJECTED,
  postCommentsStatus: PENDING | SUCCEEDED | REJECTED,
  putCommentsStatus: PENDING | SUCCEEDED | REJECTED,
  postPostsStatus: PENDING | SUCCEEDED | REJECTED,
  postPostsSilentStatus: PENDING | SUCCEEDED | REJECTED,
  addImagePostsStatus: PENDING | SUCCEEDED | REJECTED,
  addImagePostsSilentStatus: PENDING | SUCCEEDED | REJECTED,
  getImagePostsStatus: PENDING | SUCCEEDED | REJECTED,
  putPostsStatus: PENDING | SUCCEEDED | REJECTED,
  putPostsSilentStatus: PENDING | SUCCEEDED | REJECTED,
  deletePostsStatus: PENDING | SUCCEEDED | REJECTED,
  likeCommentStatus: PENDING | SUCCEEDED | REJECTED,
  likePostStatus: PENDING | SUCCEEDED | REJECTED,
  sharePostStatus: PENDING | SUCCEEDED | REJECTED,
  savePostStatus: PENDING | SUCCEEDED | REJECTED,
  getBlogPreferenceStatus: PENDING | SUCCEEDED | REJECTED,
  blogPreferenceAllContactsStatus: PENDING | SUCCEEDED | REJECTED,
  blogPreferenceAllUsersStatus: PENDING | SUCCEEDED | REJECTED,
  addBlogPreferenceStatus: PENDING | SUCCEEDED | REJECTED,
  removeBlogPreferenceStatus: PENDING | SUCCEEDED | REJECTED,
  subscribeToProfileStatus: PENDING | SUCCEEDED | REJECTED,
  pinFriendStatus: PENDING | SUCCEEDED | REJECTED,
  getPinnedFriendsStatus: PENDING | SUCCEEDED | REJECTED,
  removeFriendRequestStatus: PENDING | SUCCEEDED | REJECTED,
  getEngagementItemsStatus: PENDING | SUCCEEDED | REJECTED,
  lastSeenEngagementStatus: PENDING | SUCCEEDED | REJECTED,
  eventSeenAllStatus: PENDING | SUCCEEDED | REJECTED,
  getSavedEventsStatus: PENDING | SUCCEEDED | REJECTED,
  saveEventStatus: PENDING | SUCCEEDED | REJECTED,
  getCryptoBalanceStatus: PENDING | SUCCEEDED | REJECTED,
  getEventCommentsStatus: PENDING | SUCCEEDED | REJECTED,
  postEventCommentStatus: PENDING | SUCCEEDED | REJECTED,
  putEventCommentStatus: PENDING | SUCCEEDED | REJECTED,
  likeEventCommentStatus: PENDING | SUCCEEDED | REJECTED,
  seenVideoLinkNoticeStatus: PENDING | SUCCEEDED | REJECTED,
  blogNotifsCountStatus: PENDING | SUCCEEDED | REJECTED
}

const users = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUserSectionPage: (state, action) => {
      if (action.payload === 'clear') {
        state.userSectionPage = []
      } else if (action.payload === null) {
        state.userSectionPage.pop()
      } else if (
        action.payload
        && !state.userSectionPage.includes(action.payload)
      ) {
        state.userSectionPage.push(action.payload)
      }
    },
    setNotificationSectionPage: (state, action) => {
      if (action.payload === 'clear') {
        state.notificationSectionPage = []
      } else if (action.payload === null) {
        state.notificationSectionPage.pop()
      } else if (
        action.payload
        && !state.notificationSectionPage.find((nsp) => nsp.key === action.payload.key)
      ) {
        state.notificationSectionPage.push(action.payload)
      }
    },
    setChatSectionPage: (state, action) => {
      if (action.payload === 'clear') {
        state.chatSectionPage = []
      } else if (action.payload === null) {
        state.chatSectionPage.pop()
      } else if (
        action.payload
        && !state.chatSectionPage.includes(action.payload)
      ) {
        state.chatSectionPage.push(action.payload)
      }
    },
    setGetBlogPreferenceStatus: (state, action) => {
      state.getBlogPreferenceStatus = action.payload
    },
    clearUser: (state) => {
      // TODO remove XMPP account and logout
      state.user = null
      state.userProfile = null
      state.activeProfile = null
      state.userSectionPage = []
      state.notificationSectionPage = []
      state.posts = []
      state.comments = []
      state.blogParent = []
      state.openPopupBlogs = false
      state.chosenNotifBlog = []
      state.searchAffinities = []
      state.searchSocialLinks = []
      state.searchSocialLinksCategories = []
      state.searchBar = {}
      state.filters = []
      state.userPosition = []
      state.profileItem = null
      state.profileItemId = ''
      state.closePane = false
      state.hideNotification = false
      state.openChatModal = false
      state.closeChatModal = false
      state.sharingToFriends = false
      state.chosenFriends = []
      state.blogLinkToBeCopied = ''
      state.hideChat = false
      state.msgInputForBlogSharing = ''
      state.hideDrawerAnimation = false
      state.isBlogFormOpen = false
      state.openBlogForm = false
      state.closeAllDrawers = false
      state.markerOpenBeforeLogin = false
      state.postLastSeenData = []
      state.openFriendRequest = null
      state.selectedEngagementType = ''
      state.fromEngagementPanel = {}
      state.chosenBlogIndex = null
      state.openPopupEvents = false
      state.saveEventErrorMsg = ''
      state.savedEventId = null
      state.cryptoBalance = []
      state.openBlogLink = ''
      state.eventComments = []
      state.eventCommentTree = []
    },
    setFilters: (state, action) => {
      state.filters = action.payload
    },
    deleteFilter: (state, action) => {
      state.filters = state.filters.filter((item) => item.id !== action.payload)
    },
    setPosts: (state, action) => {
      state.posts = action.payload
    },
    setPostsTypeStatus: (state, action) => {
      state.postsTypeStatus = action.payload
    },
    setOnPostEditor: (state, action) => {
      state.onPostEditor = action.payload
    },
    setPostPostsApiMsg: (state, action) => {
      state.postPostsApiMsg = action.payload
    },
    setExecAutoArchive: (state, action) => {
      state.execAutoArchive = action.payload
    },
    setComments: (state, action) => {
      state.comments = action.payload
    },
    setBlogParent: (state, action) => {
      state.blogParent = action.payload
    },
    setOpenPopupBlogs: (state, action) => {
      state.openPopupBlogs = action.payload
    },
    setChosenNotifBlog: (state, action) => {
      state.chosenNotifBlog = action.payload
    },
    handleOpenModal: (state, action) => {
      const { section, isOpen } = action.payload
      state.isOpenRightModal = section === MODAL_SECTION?.RightSection && isOpen
      state.isOpenLeftModal = section === MODAL_SECTION?.LeftSection && isOpen
    },
    setProfileItemId: (state, { payload }) => {
      state.profileItemId = payload
    },
    deleteProfileItem: (state) => {
      state.profileItem = null
    },
    handleCloseModal: (state) => {
      state.isCloseModal = !state.isCloseModal
    },
    setIsProfileChanged: (state, action) => {
      state.isProfileChanged = action.payload
    },
    setIsPictureUploaded: (state, action) => {
      state.isPictureUploaded = action.payload
    },
    setCroppedPicture: (state, action) => {
      state.croppedPicture = action.payload
    },
    setCropFor: (state, action) => {
      state.cropFor = action.payload
    },
    setCloseResetProfileModal: (state, action) => {
      state.closeResetProfileModal = action.payload
    },
    setIsProfileActive: (state, action) => {
      state.isProfileActive = action.payload
    },
    setIsProfileIncomplete: (state, action) => {
      state.isProfileIncomplete = action.payload
    },
    setIsChangesSaved: (state, action) => {
      state.isChangesSaved = action.payload
    },
    setIsSettingPage: (state, action) => {
      state.isSettingPage = action.payload
    },
    setIsLocationOpen: (state, action) => {
      state.isLocationOpen = action.payload
    },
    setUserEdited: (state, action) => {
      state.userEdited = action.payload
    },
    setIsProfileDeleted: (state, action) => {
      state.isProfileDeleted = action.payload
    },
    clearNotifs: (state) => {
      state.adminNotifications = {}
      state.friendsNotifications = []
    },
    setAdminNotifRequest: (state, action) => {
      state.adminNotifRequest = action.payload
    },
    setIsProfileSwitched: (state, action) => {
      state.isProfileSwitched = action.payload
    },
    setPingStatus: (state, action) => {
      state.pingStatus = action.payload
    },
    clearTestData: (state) => {
      state.pingStatus = ''
      state.fileStatus = ''
      state.dataStatus = ''
      state.quoteStatus = ''
      state.serverName = ''
      state.testImage = []
      state.dataQuote = ''
      state.pingTestRes = null
      state.fileTestRes = null
      state.dataTestRes = null
      state.quoteTestRes = null
    },
    setUserPosition: (state, action) => {
      state.userPosition = action.payload
    },
    // Response Time for tests
    setResTime1: (state, action) => {
      state.pingTestRes = action.payload?.duration
      state.serverName = action.payload?.serverName
    },
    setResTime2: (state, action) => {
      state.fileTestRes = action.payload?.duration
      state.fileStatus = action.payload?.status
    },
    setResTime3: (state, action) => {
      state.dataTestRes = action.payload?.duration
      state.dataStatus = action.payload?.status
    },
    setResTime4: (state, action) => {
      state.quoteTestRes = action.payload?.duration
      state.quoteStatus = action.payload?.status
    },
    setSelectedUserProfile: (state, action) => {
      state.selectedUserProfile = action.payload
    },
    setRandomPos: (state, action) => {
      state.randomPos = action.payload
    },
    setAskForLocationServices: (state, action) => {
      state.askForLocationServices = action.payload
    },
    setClosePane: (state, action) => {
      state.closePane = action.payload
    },
    setHideNotification: (state, action) => {
      state.hideNotification = action.payload
    },
    setGetPostsStatus: (state, action) => {
      state.getPostsStatus = action.payload
    },
    setOpenChatModal: (state, action) => {
      state.openChatModal = action.payload
    },
    setCloseChatModal: (state, action) => {
      state.closeChatModal = action.payload
    },
    setSharingToFriends: (state, action) => {
      state.sharingToFriends = action.payload
    },
    setChosenFriends: (state, action) => {
      state.chosenFriends = action.payload
    },
    setBlogLinkToBeCopied: (state, action) => {
      state.blogLinkToBeCopied = action.payload
    },
    setHideChat: (state, action) => {
      state.hideChat = action.payload
    },
    setMsgInputForBlogSharing: (state, action) => {
      state.msgInputForBlogSharing = action.payload
    },
    setHideDrawerAnimation: (state, action) => {
      state.hideDrawerAnimation = action.payload
    },
    setIsBlogFormOpen: (state, action) => {
      state.isBlogFormOpen = action.payload
    },
    setOpenBlogForm: (state, action) => {
      state.openBlogForm = action.payload
    },
    setCloseAllDrawers: (state, action) => {
      state.closeAllDrawers = action.payload
    },
    setMarkerOpenBeforeLogin: (state, action) => {
      state.markerOpenBeforeLogin = action.payload
    },
    modifyAdminNotifications: (state, action) => {
      const tempNotifs = state.adminNotifications[action.payload.type]
      const notifId = action.payload.id

      state.adminNotifications[action.payload.type] = tempNotifs.filter((i) => i.id !== notifId)
    },
    setOpenFriendRequest: (state, action) => {
      state.openFriendRequest = action.payload
    },
    setAddFriendStatus: (state, action) => {
      state.addFriendStatus = action.payload
    },
    setRemoveFriendRequestStatus: (state, action) => {
      state.removeFriendRequestStatus = action.payload
    },
    setDeleteFriendStatus: (state, action) => {
      state.deleteFriendStatus = action.payload
    },
    setGetProfileItemStatus: (state, action) => {
      state.getProfileItemStatus = action.payload
    },
    setUpdateUserSettingsStatus: (state, action) => {
      state.updateUserSettingsStatus = action.payload
    },
    setGetEngagementItemsStatus: (state, action) => {
      state.getEngagementItemsStatus = action.payload
    },
    setSelectedEngagementType: (state, action) => {
      state.selectedEngagementType = action.payload
    },
    setFromEngagementPanel: (state, action) => {
      state.fromEngagementPanel = action.payload
    },
    setEngagementItems: (state, action) => {
      state.engagementItems = action.payload
    },
    setBlogLikeOngoing: (state, action) => {
      if (action.payload.type === 'post') {
        state.posts.some((post) => {
          if (post.id === action.payload.id) {
            post.likeOngoing = 1
            return true
          }
          return false
        })
      }

      if (action.payload.type === 'comment') {
        state.comments.some((comment) => {
          if (comment.comment_id === action.payload.id) {
            comment.likeOngoing = 1
            return true
          }
          return false
        })
      }
    },
    setBlogSaveOngoing: (state, action) => {
      state.posts.some((post) => {
        if (post.id === action.payload) {
          post.saveOngoing = 1
          return true
        }
        return false
      })
    },
    setChosenBlogIndex: (state, action) => {
      state.chosenBlogIndex = action.payload
    },
    setRepostThisPostData: (state, action) => {
      state.repostThisPostData = action.payload
    },
    setPostPostsStatus: (state, action) => {
      state.postPostsStatus = action.payload
    },
    setPutPostsStatus: (state, action) => {
      state.putPostsStatus = action.payload
    },
    setBlogRepostData: (state, action) => {
      state.blogRepostData = action.payload
    },
    setBlogRepostParent: (state, action) => {
      state.blogRepostParent = action.payload
    },
    setNewPostsOption: (state, action) => {
      state.newPostsOption = action.payload
    },
    setGetSavedEventsStatus: (state, action) => {
      state.getSavedEventsStatus = action.payload
    },
    setSavedEvents: (state, action) => {
      state.savedEvents = action.payload
    },
    setOpenPopupEvents: (state, action) => {
      state.openPopupEvents = action.payload
    },
    setSaveEventStatus: (state, action) => {
      state.saveEventStatus = action.payload
    },
    setDeletePostsStatus: (state, action) => {
      state.deletePostsStatus = action.payload
    },
    setSilentPostId: (state, action) => {
      state.silentPostId = action.payload
    },
    setUpdateUserProfileStatus: (state, action) => {
      state.updateUserProfileStatus = action.payload
    },
    setConnReqData: (state, action) => {
      state.connReqData = action.payload
    },
    setAcceptFriendStatus: (state, action) => {
      state.acceptFriendStatus = action.payload
    },
    setArchiveRequestStatus: (state, action) => {
      state.archiveRequestStatus = action.payload
    },
    setDenyFriendStatus: (state, action) => {
      state.denyFriendStatus = action.payload
    },
    setCryptoBalance: (state, action) => {
      state.cryptoBalance = action.payload
    },
    setOpenBlogLink: (state, action) => {
      state.openBlogLink = action.payload
    },
    setEventCommentLikeOngoing: (state, action) => {
      state.eventComments.some((ec) => {
        if (ec.comment_id === action.payload.id) {
          ec.likeOngoing = 1
          return true
        }
        return false
      })
    },
    setEventComments: (state, action) => {
      state.eventComments = action.payload
    },
    setEventCommentTree: (state, action) => {
      state.eventCommentTree = action.payload
    }
  },
  extraReducers: {
    // GET USER
    [getUser.pending]: (state) => {
      state.getUserStatus = PENDING
    },
    [getUser.fulfilled]: (state, action) => {
      state.getUserStatus = SUCCEEDED
      state.user = action.payload.data
    },
    [getUser.rejected]: (state) => {
      state.getUserStatus = REJECTED
    },
    // DELETE USER
    [deleteUser.pending]: (state) => {
      state.deleteUserStatus = PENDING
    },
    [deleteUser.fulfilled]: (state) => {
      state.deleteUserStatus = SUCCEEDED
    },
    [deleteUser.rejected]: (state) => {
      state.deleteUserStatus = REJECTED
    },
    // GET USER PROFILE
    [getUserProfile.pending]: (state) => {
      state.getUserProfileStatus = PENDING
    },
    [getUserProfile.fulfilled]: (state, action) => {
      const activeProfile = action.payload.find((item) => item.is_active)

      if (activeProfile === undefined) {
        state.filters = []
      }

      state.getUserProfileStatus = SUCCEEDED
      state.userProfile = action.payload
      state.activeProfile = activeProfile
    },
    [getUserProfile.rejected]: (state) => {
      state.getUserProfileStatus = REJECTED
    },
    // SELECT USER PROFILE
    [selectProfile.pending]: (state) => {
      state.selectProfileStatus = PENDING
    },
    [selectProfile.fulfilled]: (state) => {
      state.selectProfileStatus = SUCCEEDED
    },
    [selectProfile.rejected]: (state) => {
      state.selectProfileStatus = REJECTED
    },
    // GET AFFINITIES
    [getAffinities.pending]: (state) => {
      state.getAffinitiesStatus = PENDING
    },
    [getAffinities.fulfilled]: (state, action) => {
      state.getAffinitiesStatus = SUCCEEDED
      state.searchAffinities = action.payload
    },
    [getAffinities.rejected]: (state) => {
      state.getAffinitiesStatus = REJECTED
    },
    // UPDATE PROFILE
    [updateUserProfile.pending]: (state) => {
      state.updateUserProfileStatus = PENDING
    },
    [updateUserProfile.fulfilled]: (state) => {
      state.updateUserProfileStatus = SUCCEEDED
      state.cryptoBalance = []
    },
    [updateUserProfile.rejected]: (state) => {
      state.updateUserProfileStatus = REJECTED
    },
    // DELETE PROFILE
    [deleteUserProfile.pending]: (state) => {
      state.deleteProfileStatus = PENDING
    },
    [deleteUserProfile.fulfilled]: (state) => {
      state.deleteProfileStatus = SUCCEEDED

      localStorage.removeItem('activeProfileLat')
      localStorage.removeItem('activeProfileLng')
    },
    [deleteUserProfile.rejected]: (state) => {
      state.deleteProfileStatus = REJECTED
    },
    // GET SEARCH BAR PARAMS
    [getSearchParams.pending]: (state) => {
      state.getSearchParamsStatus = PENDING
    },
    [getSearchParams.fulfilled]: (state, action) => {
      state.getSearchParamsStatus = SUCCEEDED
      state.searchBar = action.payload
    },
    [getSearchParams.rejected]: (state) => {
      state.getSearchParamsStatus = REJECTED
    },
    // UPDATE USER SETTINGS
    [updateUserSettings.pending]: (state) => {
      state.updateUserSettingsStatus = PENDING
    },
    [updateUserSettings.fulfilled]: (state) => {
      state.updateUserSettingsStatus = SUCCEEDED
    },
    [updateUserSettings.rejected]: (state) => {
      state.updateUserSettingsStatus = REJECTED
    },
    // ADD FRIEND
    [addFriend.pending]: (state) => {
      state.addFriendStatus = PENDING
    },
    [addFriend.fulfilled]: (state, action) => {
      state.addFriendStatus = SUCCEEDED

      if (action?.payload?.data?.id === state?.profileItem?.id) {
        state.profileItem.active_connections = action.payload.data.active_connections
        state.profileItem.friendship_role = action.payload.data.friendship_role
        state.profileItem.is_friends = action.payload.data.is_friends
        state.profileItem.past_connections = action.payload.data.past_connections
      }
    },
    [addFriend.rejected]: (state, action) => {
      state.addFriendStatus = REJECTED

      if (action?.payload?.data?.data?.id === state?.profileItem?.id) {
        state.profileItem.active_connections = action.payload.data.data.active_connections
        state.profileItem.friendship_role = action.payload.data.data.friendship_role
        state.profileItem.is_friends = action.payload.data.data.is_friends
        state.profileItem.past_connections = action.payload.data.data.past_connections
      }
    },
    // DELETE FRIEND
    [deleteFriend.pending]: (state) => {
      state.deleteFriendStatus = PENDING
    },
    [deleteFriend.fulfilled]: (state, action) => {
      state.deleteFriendStatus = SUCCEEDED

      if (action?.payload?.data?.id === state?.profileItem?.id) {
        state.profileItem.active_connections = action.payload.data.active_connections
        state.profileItem.friendship_role = action.payload.data.friendship_role
        state.profileItem.is_friends = action.payload.data.is_friends
        state.profileItem.past_connections = action.payload.data.past_connections
      }
    },
    [deleteFriend.rejected]: (state, action) => {
      state.deleteFriendStatus = REJECTED

      if (action?.payload?.data?.data?.id === state?.profileItem?.id) {
        state.profileItem.active_connections = action.payload.data.data.active_connections
        state.profileItem.friendship_role = action.payload.data.data.friendship_role
        state.profileItem.is_friends = action.payload.data.data.is_friends
        state.profileItem.past_connections = action.payload.data.data.past_connections
      }
    },
    // REMOVE FRIEND REQUEST
    [removeFriendRequest.pending]: (state) => {
      state.removeFriendRequestStatus = PENDING
    },
    [removeFriendRequest.fulfilled]: (state, action) => {
      state.removeFriendRequestStatus = SUCCEEDED

      if (action?.payload?.data?.id === state?.profileItem?.id) {
        state.profileItem.active_connections = action.payload.data.active_connections
        state.profileItem.friendship_role = action.payload.data.friendship_role
        state.profileItem.is_friends = action.payload.data.is_friends
        state.profileItem.past_connections = action.payload.data.past_connections
      }
    },
    [removeFriendRequest.rejected]: (state, action) => {
      state.removeFriendRequestStatus = REJECTED

      if (action?.payload?.data?.data?.id === state?.profileItem?.id) {
        state.profileItem.active_connections = action.payload.data.data.active_connections
        state.profileItem.friendship_role = action.payload.data.data.friendship_role
        state.profileItem.is_friends = action.payload.data.data.is_friends
        state.profileItem.past_connections = action.payload.data.data.past_connections
      }
    },
    // GET NOTIFICATION
    [getFriendsNotifications.pending]: (state) => {
      state.getFriendsNotificationsStatus = PENDING
    },
    [getFriendsNotifications.fulfilled]: (state, action) => {
      state.getFriendsNotificationsStatus = SUCCEEDED
      state.friendsNotifications = action.payload
    },
    [getFriendsNotifications.rejected]: (state) => {
      state.getFriendsNotificationsStatus = REJECTED
    },
    // ACCEPT FRIEND
    [acceptFriend.pending]: (state) => {
      state.acceptFriendStatus = PENDING

      if (state.connReqData?.blocked_at) {
        state.blockedRequest.map((br) => {
          if (br?.friend_request_id === state.connReqData.friend_request_id) {
            br.disabled = true
          }

          return br
        })
      } else {
        state.friendsNotifications.map((fn) => {
          if (fn?.friend_request_id === state.connReqData.friend_request_id) {
            fn.disabled = true
          }

          return fn
        })
      }
    },
    [acceptFriend.fulfilled]: (state) => {
      state.acceptFriendStatus = SUCCEEDED
    },
    [acceptFriend.rejected]: (state, action) => {
      state.acceptFriendStatus = REJECTED

      state.blockedRequest.map((br) => {
        if (br?.sender_id === action?.payload?.sender_id) {
          br.disabled = false
        }

        return br
      })

      state.friendsNotifications.map((fn) => {
        if (fn?.sender_id === action?.payload?.sender_id) {
          fn.disabled = false
        }

        return fn
      })

      if ((action?.payload?.data?.message).includes('Friend request')) {
        const newFriendsNotif = state.friendsNotifications.filter(
          (item) => item?.sender_id !== Number(action?.meta?.arg?.id)
        )
        state.friendsNotifications = newFriendsNotif

        const newBlockedFriendsNotif = state.blockedRequest.filter(
          (item) => item?.sender_id !== Number(action?.meta?.arg?.id)
        )
        state.blockedRequest = newBlockedFriendsNotif
      }
    },
    // DENY FRIEND
    [denyFriend.pending]: (state, action) => {
      state.denyFriendStatus = PENDING
      const { id } = action.meta.arg

      state.adminNotifications.community_blogs = state.adminNotifications.community_blogs
        .filter((i) => !(i.type === 'subscribed' && i.id === parseInt(id, 10)))
    },
    [denyFriend.fulfilled]: (state) => {
      state.denyFriendStatus = SUCCEEDED
    },
    [denyFriend.rejected]: (state) => {
      state.denyFriendStatus = REJECTED
    },
    [getProfileItem.pending]: (state) => {
      state.profileItem = null
      state.getProfileItemStatus = PENDING
    },
    [getProfileItem.fulfilled]: (state, { payload }) => {
      if (String(payload.id) === sessionStorage.getItem('id')) {
        state.profileItem = payload
        state.getProfileItemStatus = SUCCEEDED
      }
    },
    [getProfileItem.rejected]: (state) => {
      state.getProfileItemStatus = REJECTED
    },
    // ADMIN NOTIFICATIONS
    [getAdminNotifications.pending]: (state) => {
      state.getAdminNotificationsStatus = PENDING
    },
    [getAdminNotifications.fulfilled]: (state, { payload }) => {
      state.getAdminNotificationsStatus = SUCCEEDED
      state.adminNotifications = payload
    },
    [getAdminNotifications.rejected]: (state) => {
      state.getAdminNotificationsStatus = REJECTED
    },
    // MAKE NOTIFICATION SEEN
    [postMakeNotificationSeen.pending]: (state, action) => {
      state.postMakeNotificationSeenStatus = PENDING
      const {
        notificationId,
        title
      } = action.meta.arg

      const item = state.adminNotifications[title]?.find(
        (notif) => notif.id === notificationId
          && notif.related_to === null
      )

      if (item) {
        item.is_viewed = 1
      }
    },
    [postMakeNotificationSeen.fulfilled]: (state) => {
      state.postMakeNotificationSeenStatus = SUCCEEDED
    },
    [postMakeNotificationSeen.rejected]: (state) => {
      state.postMakeNotificationSeenStatus = REJECTED
    },
    // MAKE NOTIFICATION SEEN ALL
    [postMakeNotificationSeenAll.pending]: (state) => {
      state.postMakeNotificationSeenAllStatus = PENDING
    },
    [postMakeNotificationSeenAll.fulfilled]: (state, action) => {
      state.postMakeNotificationSeenAllStatus = SUCCEEDED
      const { idList } = action.meta.arg

      state.adminNotifications.new_users = state.adminNotifications.new_users
        .map((item) => {
          if (idList.includes(item?.id)) {
            item.is_viewed = 1
          }

          return item
        })
    },
    [postMakeNotificationSeenAll.rejected]: (state) => {
      state.postMakeNotificationSeenAllStatus = REJECTED
    },
    // MAKE CONNECTION REQUEST SEEN ALL
    [connectionRequestSeenAll.pending]: (state) => {
      state.connectionRequestSeenAllStatus = PENDING
    },
    [connectionRequestSeenAll.fulfilled]: (state) => {
      state.connectionRequestSeenAllStatus = SUCCEEDED

      state.friendsNotifications = state.friendsNotifications
        ?.map((item) => {
          item.is_viewed = 1

          return item
        })

      state.blockedRequest = state.blockedRequest
        ?.map((item) => {
          item.is_viewed = 1

          return item
        })
    },
    [connectionRequestSeenAll.rejected]: (state) => {
      state.connectionRequestSeenAllStatus = REJECTED
    },
    // GET SOCIAL Links
    [getSocialLinks.pending]: (state) => {
      state.getSocialLinksStatus = PENDING
    },
    [getSocialLinks.fulfilled]: (state, action) => {
      state.getSocialLinksStatus = SUCCEEDED
      state.searchSocialLinks = action.payload
    },
    [getSocialLinks.rejected]: (state) => {
      state.getSocialLinksStatus = REJECTED
    },
    // GET SOCIAL Links Categories
    [getSocialLinksCategories.pending]: (state) => {
      state.getSocialLinksCategoriesStatus = PENDING
    },
    [getSocialLinksCategories.fulfilled]: (state, action) => {
      state.getSocialLinksCategoriesStatus = SUCCEEDED
      state.searchSocialLinksCategories = action.payload
    },
    [getSocialLinksCategories.rejected]: (state) => {
      state.getSocialLinksCategoriesStatus = REJECTED
    },
    // GET FREQUENCY
    [getFrequency.pending]: (state) => {
      state.getFrequencyStatus = PENDING
    },
    [getFrequency.fulfilled]: (state, action) => {
      state.getFrequencyStatus = SUCCEEDED
      state.frequency = action.payload
    },
    [getFrequency.rejected]: (state) => {
      state.getFrequencyStatus = REJECTED
    },
    // SET LIVE LOCATION DATA
    [setLiveLocData.pending]: (state) => {
      state.setLiveLocDataStatus = PENDING
    },
    [setLiveLocData.fulfilled]: (state, action) => {
      state.setLiveLocDataStatus = SUCCEEDED
      state.liveLocationCoordinates = action.payload

      const { id, coordinates } = action.meta.arg
      if (id === state.activeProfile.id) {
        state.activeProfile.coordinates = coordinates
      }
    },
    [setLiveLocData.rejected]: (state) => {
      state.setLiveLocDataStatus = REJECTED
    },
    // GET PING TEST
    [getPingTest.pending]: (state) => {
      state.getPingTestStatus = PENDING
    },
    [getPingTest.fulfilled]: (state) => {
      state.getPingTestStatus = SUCCEEDED
    },
    [getPingTest.rejected]: (state) => {
      state.getPingTestStatus = REJECTED
    },
    // GET IMAGE TEST
    [getFileTest.pending]: (state) => {
      state.getFileTestStatus = PENDING
    },
    [getFileTest.fulfilled]: (state, action) => {
      state.getFileTestStatus = SUCCEEDED
      state.testImage = action.payload
    },
    [getFileTest.rejected]: (state) => {
      state.getFileTestStatus = REJECTED
    },
    // SET DATA TEST
    [setDataTest.pending]: (state) => {
      state.setDataTestStatus = PENDING
    },
    [setDataTest.fulfilled]: (state, action) => {
      state.setDataTestStatus = SUCCEEDED
      state.dataQuote = action.payload
    },
    [setDataTest.rejected]: (state) => {
      state.setDataTestStatus = REJECTED
    },
    // ARCHIVE REQUEST
    [archiveRequest.pending]: (state) => {
      state.archiveRequestStatus = PENDING

      if (state.connReqData?.blocked_at) {
        state.blockedRequest.map((br) => {
          if (br?.friend_request_id === state.connReqData.friend_request_id) {
            br.disabled = true
          }

          return br
        })
      } else {
        state.friendsNotifications.map((fn) => {
          if (fn?.friend_request_id === state.connReqData.friend_request_id) {
            fn.disabled = true
          }

          return fn
        })
      }
    },
    [archiveRequest.fulfilled]: (state) => {
      state.archiveRequestStatus = SUCCEEDED
    },
    [archiveRequest.rejected]: (state, action) => {
      state.archiveRequestStatus = REJECTED

      state.blockedRequest.map((br) => {
        if (br?.sender_id === action?.payload?.sender_id) {
          br.disabled = false
        }

        return br
      })

      state.friendsNotifications.map((fn) => {
        if (fn?.sender_id === action?.payload?.sender_id) {
          fn.disabled = false
        }

        return fn
      })
    },
    // BLOCKED REQUESTS
    [getBlockedRequest.pending]: (state) => {
      state.getBlockedRequestStatus = PENDING

      if (state.connReqData?.blocked_at) {
        state.blockedRequest.map((br) => {
          if (br?.friend_request_id === state.connReqData.friend_request_id) {
            br.disabled = true
          }

          return br
        })
      } else {
        state.friendsNotifications.map((fn) => {
          if (fn?.friend_request_id === state.connReqData.friend_request_id) {
            fn.disabled = true
          }

          return fn
        })
      }
    },
    [getBlockedRequest.fulfilled]: (state, action) => {
      state.getBlockedRequestStatus = SUCCEEDED
      state.blockedRequest = action.payload
    },
    [getBlockedRequest.rejected]: (state, action) => {
      state.getBlockedRequestStatus = REJECTED

      state.blockedRequest.map((br) => {
        if (br?.sender_id === action?.payload?.sender_id) {
          br.disabled = false
        }

        return br
      })

      state.friendsNotifications.map((fn) => {
        if (fn?.sender_id === action?.payload?.sender_id) {
          fn.disabled = false
        }

        return fn
      })
    },
    // GET POSTS REQUEST
    [getPosts.pending]: (state, action) => {
      state.getPostsStatus = PENDING

      if (action.meta.arg.from === 'repost') {
        state.newPostsOption = action.meta.arg
      } else {
        state.postsOption = action.meta.arg
      }
    },
    [getPosts.fulfilled]: (state, action) => {
      state.getPostsStatus = SUCCEEDED
      const payload = action.meta.arg
      state.postLastSeenData = payload

      if (state.newPostsOption?.changeTo) {
        state.newPostsOption.type = state.newPostsOption.changeTo
        delete state.newPostsOption.changeTo
      }

      if (payload?.from === 'repost') {
        const [firstPost] = action.payload.posts
        state.blogRepostData.pop()
        state.blogRepostData.push(firstPost)

        return
      }

      if (!payload?.lastItemId) {
        state.posts = []
      }

      if (state.posts.length) {
        action.payload.posts.forEach((post) => state.posts.push(post))
      } else {
        state.posts = action.payload.posts
      }

      if (
        state.fromEngagementPanel?.clicked
        && state.fromEngagementPanel?.type === 'comment'
        && state.posts.length
      ) {
        state.fromEngagementPanel = {}
        state.blogParent.unshift(action.payload.posts[0])
      }
    },
    [getPosts.rejected]: (state) => {
      state.getPostsStatus = REJECTED
    },
    // PUT LAST SEEN OF BLOG CATEGORIES REQUEST
    [updateLastSeenOfPost.pending]: (state) => {
      state.updateLastSeenOfPostStatus = PENDING

      const modified = state.adminNotifications.community_blogs
        .find((e) => e.type === state.postLastSeenData?.type && e.id === state.postLastSeenData?.id)
      delete modified?.new_post_count

      state.adminNotifications.community_blogs = state.adminNotifications.community_blogs
        .map((e) => {
          if (e.id === state.postLastSeenData?.id && e.type === state.postLastSeenData?.type) {
            return modified
          }

          return e
        })
    },
    [updateLastSeenOfPost.fulfilled]: (state) => {
      state.updateLastSeenOfPostStatus = SUCCEEDED
    },
    [updateLastSeenOfPost.rejected]: (state) => {
      state.updateLastSeenOfPostStatus = REJECTED
    },
    // POST POSTS REQUEST
    [postPosts.pending]: (state) => {
      state.postPostsStatus = PENDING
    },
    [postPosts.fulfilled]: (state, action) => {
      state.postPostsStatus = SUCCEEDED
      action.payload.post.forEach((item) => state.posts.unshift(item))
    },
    [postPosts.rejected]: (state) => {
      state.postPostsStatus = REJECTED
    },
    // POST POSTS SILENT REQUEST
    [postPostsSilent.pending]: (state) => {
      state.postPostsSilentStatus = PENDING
    },
    [postPostsSilent.fulfilled]: (state, action) => {
      state.postPostsSilentStatus = SUCCEEDED

      if (state.postsTypeStatus !== 'archived') {
        state.silentPostId = action.payload.post[0]?.id
      }

      if (state.postsTypeStatus === 'archived') {
        action.payload.post.forEach((item) => state.posts.unshift(item))
      }
    },
    [postPostsSilent.rejected]: (state) => {
      state.postPostsSilentStatus = REJECTED
    },
    // ADD IMAGE POST REQUEST
    [addImagePosts.pending]: (state) => {
      state.addImagePostsStatus = PENDING
    },
    [addImagePosts.fulfilled]: (state) => {
      state.addImagePostsStatus = SUCCEEDED
    },
    [addImagePosts.rejected]: (state) => {
      state.addImagePostsStatus = REJECTED
    },
    // ADD IMAGE POST SILENT REQUEST
    [addImagePostsSilent.pending]: (state) => {
      state.addImagePostsSilentStatus = PENDING
    },
    [addImagePostsSilent.fulfilled]: (state) => {
      state.addImagePostsSilentStatus = SUCCEEDED
    },
    [addImagePostsSilent.rejected]: (state) => {
      state.addImagePostsSilentStatus = REJECTED
    },
    // GET IMAGE POST REQUEST
    [getImagePosts.pending]: (state) => {
      state.getImagePostsStatus = PENDING
    },
    [getImagePosts.fulfilled]: (state, action) => {
      state.getImagePostsStatus = SUCCEEDED
      const {
        postId,
        parentPostId,
        fileName,
        type
      } = action.meta.arg

      state.posts.some((post) => {
        if (
          type === 'repostedArticle'
          && post.id === parentPostId
          && post.repost_post_id === postId
        ) {
          post.repostPostData.body.entityMap = Object
            .values(post.repostPostData.body.entityMap)
            .reduce((acc, entity, key) => {
              if (entity?.data?.src === fileName) {
                entity.data.src = `data:image/${fileName.split('.')[1]};base64,${Buffer.from(action.payload, 'binary').toString('base64')}`
              }

              acc[key] = entity
              return acc
            }, {})
          post.repostPostData.imageLoaded += 1

          return true
        }

        if (post.id === postId) {
          post.body.entityMap = Object
            .values(post.body.entityMap)
            .reduce((acc, entity, key) => {
              if (entity?.data?.src === fileName) {
                entity.data.src = `data:image/${fileName.split('.')[1]};base64,${Buffer.from(action.payload, 'binary').toString('base64')}`
              }

              acc[key] = entity
              return acc
            }, {})
          post.imageLoaded += 1

          return true
        }

        return false
      })

      state.blogRepostData?.forEach((e) => {
        if (e.id === postId) {
          e.body.entityMap = Object
            .values(e.body.entityMap)
            .reduce((acc, entity, key) => {
              if (entity?.data?.src === fileName) {
                entity.data.src = `data:image/${fileName.split('.')[1]};base64,${Buffer.from(action.payload, 'binary').toString('base64')}`
              }

              acc[key] = entity
              return acc
            }, {})
          e.imageLoaded += 1
        }

        if (e.repostPostData?.id === postId) {
          e.repostPostData.body.entityMap = Object
            .values(e.repostPostData.body.entityMap)
            .reduce((acc, entity, key) => {
              if (entity?.data?.src === fileName) {
                entity.data.src = `data:image/${fileName.split('.')[1]};base64,${Buffer.from(action.payload, 'binary').toString('base64')}`
              }

              acc[key] = entity
              return acc
            }, {})
          e.repostPostData.imageLoaded += 1
        }
      })
    },
    [getImagePosts.rejected]: (state) => {
      state.getImagePostsStatus = REJECTED
    },
    // PUT POSTS REQUEST
    [putPosts.pending]: (state) => {
      state.putPostsStatus = PENDING
    },
    [putPosts.fulfilled]: (state, action) => {
      state.putPostsStatus = SUCCEEDED

      action.payload.post.forEach((item) => {
        state.posts = state.posts.map((post) => {
          const isUpdated = post?.id === item?.id
          return isUpdated ? item : post
        })
      })
    },
    [putPosts.rejected]: (state) => {
      state.putPostsStatus = REJECTED
    },
    // PUT POSTS SILENT REQUEST
    [putPostsSilent.pending]: (state) => {
      state.putPostsSilentStatus = PENDING
    },
    [putPostsSilent.fulfilled]: (state, action) => {
      state.putPostsSilentStatus = SUCCEEDED

      if (state.postsTypeStatus !== 'archived') {
        state.silentPostId = action.payload.post[0]?.id
      }

      if (state.postsTypeStatus === 'archived') {
        action.payload.post.forEach((item) => {
          state.posts = state.posts.map((post) => {
            const isUpdated = post?.id === item?.id
            return isUpdated ? item : post
          })
        })
      }
    },
    [putPostsSilent.rejected]: (state) => {
      state.putPostsSilentStatus = REJECTED
    },
    // DELETE POSTS REQUEST
    [deletePosts.pending]: (state) => {
      state.deletePostsStatus = PENDING
    },
    [deletePosts.fulfilled]: (state, action) => {
      state.deletePostsStatus = SUCCEEDED
      const payload = action.meta.arg

      state.posts = state.posts.filter((post) => post.id !== payload.post_id)
    },
    [deletePosts.rejected]: (state) => {
      state.deletePostsStatus = REJECTED
    },
    // LIKE POST REQUEST
    [likePost.pending]: (state, action) => {
      state.likePostStatus = PENDING
      const postId = action.meta.arg

      state.posts.some((post) => {
        if (post.id === postId) {
          if (post.likedByMe) {
            post.likes -= 1
            post.likedByMe = 0
          } else {
            post.likes += 1
            post.likedByMe = 1
          }

          return true
        }
        return false
      })

      state.blogRepostData?.forEach((e) => {
        if (e.id === postId) {
          if (e.likedByMe) {
            e.likes -= 1
            e.likedByMe = 0
          } else {
            e.likes += 1
            e.likedByMe = 1
          }
        }
      })
    },
    [likePost.fulfilled]: (state, action) => {
      state.likePostStatus = SUCCEEDED
      const data = action.payload

      state.posts.some((post) => {
        if (post.id === data.id) {
          post.likes = data.likesCount
          post.likedByMe = data.action === 'like' ? 1 : 0
          post.likeOngoing = 0

          return true
        }
        return false
      })

      state.blogRepostData?.forEach((e) => {
        if (e.id === data.id) {
          e.likes = data.likesCount
          e.likedByMe = data.action === 'like' ? 1 : 0
          e.likeOngoing = 0
        }
      })
    },
    [likePost.rejected]: (state, action) => {
      state.likePostStatus = REJECTED
      const postId = action.meta.arg

      state.posts.some((post) => {
        if (post.id === postId) {
          post.likeOngoing = 0

          if (post.likedByMe) {
            post.likes -= 1
            post.likedByMe = 0
          } else {
            post.likes += 1
            post.likedByMe = 1
          }

          return true
        }
        return false
      })

      state.blogRepostData?.forEach((e) => {
        if (e.id === postId) {
          if (e.likedByMe) {
            e.likes -= 1
            e.likedByMe = 0
          } else {
            e.likes += 1
            e.likedByMe = 1
          }
        }
      })
    },
    // SHARE POST REQUEST
    [sharePost.pending]: (state, action) => {
      state.sharePostStatus = PENDING
      const postId = action.meta.arg

      state.posts.some((post) => {
        if (post.id === parseInt(postId, 10)) {
          post.shares += 1

          return true
        }

        return false
      })

      state.blogRepostData?.forEach((e) => {
        if (e.id === parseInt(postId, 10)) {
          e.shares += 1
        }
      })
    },
    [sharePost.fulfilled]: (state, action) => {
      state.sharePostStatus = SUCCEEDED
      const data = action.payload

      state.posts.some((post) => {
        if (post.id === data.id) {
          post.shares = data.sharesCount

          return true
        }

        return false
      })
    },
    [sharePost.rejected]: (state) => {
      state.sharePostStatus = REJECTED
    },
    // SAVE POST REQUEST
    [savePost.pending]: (state, action) => {
      state.savePostStatus = PENDING
      const postId = action.meta.arg

      if (state.selectedEngagementType === ENGAGEMENT_TYPES.saves) {
        state.engagementItems = state.engagementItems.filter(
          (item) => item.post_id !== postId
        )
      }

      state.posts.some((post) => {
        if (post.id === postId) {
          if (post.savedByMe) {
            post.saves -= 1
            post.savedByMe = 0
          } else {
            post.saves += 1
            post.savedByMe = 1

            if (
              state.selectedEngagementType === ENGAGEMENT_TYPES.saves
              && state.blogRepostData.length === 0
            ) {
              const now = new Date()
              const formatted = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} `
                + `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`

              state.engagementItems.unshift({
                sbId: post.id + Math.floor(Date.now() / 1000),
                post_id: post.id,
                post_title: post.title,
                profile_id: post.profile_id,
                profile_picture: post.profile_picture,
                coordinates: post.coordinates,
                imageLoaded: 0,
                created_at: formatted
              })
            }
          }

          return true
        }
        return false
      })

      state.blogRepostData?.forEach((e) => {
        if (e.id === parseInt(postId, 10)) {
          if (e.savedByMe) {
            e.saves -= 1
            e.savedByMe = 0
          } else {
            e.saves += 1
            e.savedByMe = 1

            if (state.selectedEngagementType === ENGAGEMENT_TYPES.saves) {
              const now = new Date()
              const formatted = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} `
                + `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`

              state.engagementItems.unshift({
                sbId: e.id + Math.floor(Date.now() / 1000),
                post_id: e.id,
                post_title: e.title,
                profile_id: e.profile_id,
                profile_picture: e.profile_picture,
                coordinates: e.coordinates,
                imageLoaded: 0,
                created_at: formatted
              })
            }
          }
        }
      })
    },
    [savePost.fulfilled]: (state, action) => {
      state.savePostStatus = SUCCEEDED
      const data = action.payload

      state.posts.some((post) => {
        if (post.id === data.id) {
          post.saves = data.savesCount
          post.savedByMe = data.action === 'save' ? 1 : 0
          post.saveOngoing = 0

          return true
        }

        return false
      })

      state.blogRepostData?.forEach((e) => {
        if (e.id === data.id) {
          e.saves = data.savesCount
          e.savedByMe = data.action === 'save' ? 1 : 0
          e.saveOngoing = 0
        }
      })

      if (
        data.action === 'save'
        && state.selectedEngagementType === ENGAGEMENT_TYPES.saves
      ) {
        state.engagementItems.some((item) => {
          if (item.post_id === data.id) {
            item.sbId = data.sbId
            item.post_image = data.firstImage
            item.created_at = data?.createdAt
            item.imageLoaded = 1

            return true
          }

          return false
        })
      }
    },
    [savePost.rejected]: (state, action) => {
      state.savePostStatus = REJECTED
      const postId = action.meta.arg

      state.posts.some((post) => {
        if (post.id === postId) {
          post.saveOngoing = 0

          if (post.savedByMe) {
            post.saves -= 1
            post.savedByMe = 0

            if (state.selectedEngagementType === ENGAGEMENT_TYPES.saves) {
              state.engagementItems = state.engagementItems.filter(
                (item) => item.post_id !== postId
              )
            }
          } else {
            post.saves += 1
            post.savedByMe = 1

            if (state.selectedEngagementType === ENGAGEMENT_TYPES.saves) {
              const now = new Date()
              const formatted = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} `
                    + `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`

              state.engagementItems.unshift({
                post_id: post.id,
                post_title: post.title,
                profile_id: post.profile_id,
                profile_picture: post.profile_picture,
                coordinates: post.coordinates,
                imageLoaded: 0,
                created_at: formatted
              })
            }
          }

          return true
        }
        return false
      })

      state.blogRepostData?.forEach((e) => {
        if (e.id === parseInt(postId, 10)) {
          if (e.savedByMe) {
            e.saves -= 1
            e.savedByMe = 0

            if (state.selectedEngagementType === ENGAGEMENT_TYPES.saves) {
              state.engagementItems = state.engagementItems.filter(
                (item) => item.post_id !== postId
              )
            }
          } else {
            e.saves += 1
            e.savedByMe = 1

            if (state.selectedEngagementType === ENGAGEMENT_TYPES.saves) {
              const now = new Date()
              const formatted = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} `
                + `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`

              state.engagementItems.unshift({
                sbId: e.id + Math.floor(Date.now() / 1000),
                post_id: e.id,
                post_title: e.title,
                profile_id: e.profile_id,
                profile_picture: e.profile_picture,
                coordinates: e.coordinates,
                imageLoaded: 0,
                created_at: formatted
              })
            }
          }
        }
      })
    },
    // GET BLOG PREFERENCE
    [getBlogPreference.pending]: (state) => {
      state.getBlogPreferenceStatus = PENDING
    },
    [getBlogPreference.fulfilled]: (state, action) => {
      state.getBlogPreferenceStatus = SUCCEEDED
      state.blogPreference = action.payload.data
    },
    [getBlogPreference.rejected]: (state) => {
      state.getBlogPreferenceStatus = REJECTED
    },
    // SET BLOG PREFERENCE FOR ALL CONTACTS
    [blogPreferenceAllContacts.pending]: (state) => {
      state.blogPreferenceAllContactsStatus = PENDING
    },
    [blogPreferenceAllContacts.fulfilled]: (state, action) => {
      state.blogPreferenceAllContactsStatus = SUCCEEDED

      const isAdd = action.payload.action === 'add' ? 1 : 0
      state.blogPreference.all_contacts = isAdd

      if (isAdd) {
        state.adminNotifications.community_blogs.splice(1, 0, action.payload.all_contacts)
      } else {
        const modified = state.adminNotifications.community_blogs.filter((i) => i.type !== 'friends')
        state.adminNotifications.community_blogs = modified
      }
    },
    [blogPreferenceAllContacts.rejected]: (state) => {
      state.blogPreferenceAllContactsStatus = REJECTED
    },
    // SET BLOG PREFERENCE FOR ALL USERS
    [blogPreferenceAllUsers.pending]: (state) => {
      state.blogPreferenceAllUsersStatus = PENDING
    },
    [blogPreferenceAllUsers.fulfilled]: (state, action) => {
      state.blogPreferenceAllUsersStatus = SUCCEEDED

      const isAdd = action.payload.action === 'add' ? 1 : 0
      state.blogPreference.all_users = action.payload.all_users

      if (isAdd) {
        if (state.adminNotifications.community_blogs[1].title === 'All Contacts Blog') {
          state.adminNotifications.community_blogs.splice(2, 0, action.payload.all_users)
        } else {
          state.adminNotifications.community_blogs.splice(1, 0, action.payload.all_users)
        }
      } else {
        const modified = state.adminNotifications.community_blogs.filter((i) => i.type !== 'all')
        state.adminNotifications.community_blogs = modified
      }
    },
    [blogPreferenceAllUsers.rejected]: (state) => {
      state.blogPreferenceAllUsersStatus = REJECTED
    },
    // SET BLOG PREFERENCE FOR AFFINITIES
    [addBlogPreference.pending]: (state) => {
      state.addBlogPreferenceStatus = PENDING
    },
    [addBlogPreference.fulfilled]: (state, action) => {
      state.addBlogPreferenceStatus = SUCCEEDED

      if (state.adminNotifications.community_blogs[1].title === 'All Contacts Blog') {
        if (state.adminNotifications.community_blogs[2].title === 'All Users Blog') {
          state.adminNotifications.community_blogs.splice(3, 0, action.payload.blogPrefInfo)
        } else {
          state.adminNotifications.community_blogs.splice(2, 0, action.payload.blogPrefInfo)
        }
      } else if (state.adminNotifications.community_blogs[1].title === 'All Users Blog') {
        state.adminNotifications.community_blogs.splice(2, 0, action.payload.blogPrefInfo)
      } else {
        state.adminNotifications.community_blogs.splice(1, 0, action.payload.blogPrefInfo)
      }
    },
    [addBlogPreference.rejected]: (state) => {
      state.addBlogPreferenceStatus = REJECTED
    },
    // REMOVE BLOG PREFERENCE FOR AFFINITIES
    [removeBlogPreference.pending]: (state) => {
      state.removeBlogPreferenceStatus = PENDING
    },
    [removeBlogPreference.fulfilled]: (state, action) => {
      state.removeBlogPreferenceStatus = SUCCEEDED
      const blogPrefId = action.meta.arg

      const modified = state.adminNotifications.community_blogs.filter((i) => i.id !== blogPrefId)
      state.adminNotifications.community_blogs = modified
    },
    [removeBlogPreference.rejected]: (state) => {
      state.removeBlogPreferenceStatus = REJECTED
    },
    // GET COMMENTS REQUEST
    [getComments.pending]: (state, action) => {
      state.getCommentsStatus = PENDING

      state.commentsOption = action.meta.arg
    },
    [getComments.fulfilled]: (state, action) => {
      state.getCommentsStatus = SUCCEEDED
      const payload = action.meta.arg

      if (!payload?.lastItemId) {
        state.comments = []
      }

      action.payload.comments.forEach((comment) => {
        const exists = state.comments.some((c) => c.comment_id === comment.comment_id)

        if (!exists) {
          state.comments.push(comment)
        }
      })
    },
    [getComments.rejected]: (state) => {
      state.getCommentsStatus = REJECTED
    },
    // POST COMMENTS REQUEST
    [postComments.pending]: (state) => {
      state.postCommentsStatus = PENDING
    },
    [postComments.fulfilled]: (state, action) => {
      state.postCommentsStatus = SUCCEEDED
      const commentData = action.payload.comment

      commentData.forEach((item) => state.comments.unshift(item))

      state.posts.some((post) => {
        if (post.id === state.blogParent[0]?.id) {
          post.comments += 1

          return true
        }

        return false
      })

      state.blogRepostData?.forEach((e) => {
        if (e.id === state.blogRepostParent[0]?.id) {
          e.comments += 1
        }
      })
    },
    [postComments.rejected]: (state) => {
      state.postCommentsStatus = REJECTED
    },
    // PUT COMMENTS REQUEST
    [putComments.pending]: (state) => {
      state.putCommentsStatus = PENDING
    },
    [putComments.fulfilled]: (state, action) => {
      state.putCommentsStatus = SUCCEEDED

      action.payload.comment.forEach((item) => {
        state.comments = state.comments.map((comment) => {
          const isUpdated = comment?.comment_id === item?.comment_id
          return isUpdated ? item : comment
        })
      })
    },
    [putComments.rejected]: (state) => {
      state.putCommentsStatus = REJECTED
    },
    // LIKE COMMENT REQUEST
    [likeComment.pending]: (state, action) => {
      state.likeCommentStatus = PENDING
      const commentId = action.meta.arg

      state.comments.some((comment) => {
        if (comment.comment_id === commentId) {
          if (comment.likedByMe) {
            comment.likes -= 1
            comment.likedByMe = 0
          } else {
            comment.likes += 1
            comment.likedByMe = 1
          }

          return true
        }
        return false
      })
    },
    [likeComment.fulfilled]: (state, action) => {
      state.likeCommentStatus = SUCCEEDED
      const data = action.payload

      state.comments.some((comment) => {
        if (comment.comment_id === data.id) {
          comment.likes = data.likesCount
          comment.likedByMe = data.action === 'like' ? 1 : 0
          comment.likeOngoing = 0

          return true
        }
        return false
      })
    },
    [likeComment.rejected]: (state, action) => {
      state.likeCommentStatus = REJECTED
      const commentId = action.meta.arg

      state.comments.some((comment) => {
        if (comment.id === commentId) {
          comment.likeOngoing = 0

          if (comment.likedByMe) {
            comment.likes -= 1
            comment.likedByMe = 0
          } else {
            comment.likes += 1
            comment.likedByMe = 1
          }

          return true
        }
        return false
      })
    },
    // SUBSCRIBE/UNSUBSCRIBE TO PROFILE BLOG REQUEST
    [subscribeToProfile.pending]: (state) => {
      state.subscribeToProfileStatus = PENDING
    },
    [subscribeToProfile.fulfilled]: (state, action) => {
      state.subscribeToProfileStatus = SUCCEEDED

      const isSubscribed = action.payload.message === 'Subscribed' ? 1 : 0
      const { subscribeId } = action.meta.arg

      if (isSubscribed) {
        if (state.adminNotifications.community_blogs[1].title === 'All Contacts Blog') {
          if (state.adminNotifications.community_blogs[2].title === 'All Users Blog') {
            state.adminNotifications.community_blogs.splice(3, 0, action.payload.data)
          } else {
            state.adminNotifications.community_blogs.splice(2, 0, action.payload.data)
          }
        } else if (state.adminNotifications.community_blogs[1].title === 'All Users Blog') {
          state.adminNotifications.community_blogs.splice(2, 0, action.payload.data)
        } else {
          state.adminNotifications.community_blogs.splice(1, 0, action.payload.data)
        }
      } else {
        state.adminNotifications.community_blogs.find((item, index) => {
          if (item?.id === subscribeId) {
            state.adminNotifications.community_blogs.splice(index, 1)
            return true
          }

          return false
        })
      }

      const updatedPosts = state.posts.map((post) => {
        if (subscribeId === post.profile_id) {
          return { ...post, isSubscribed }
        }
        return post
      })
      state.posts = updatedPosts

      state.engagementItems = state.engagementItems.map((item) => {
        if (item?.profile_id === subscribeId) {
          item.isSubscribed = isSubscribed
        }

        return item
      })

      state.blogRepostData?.forEach((e) => {
        if (e.profile_id === subscribeId) {
          e.isSubscribed = isSubscribed
        }
      })
    },
    [subscribeToProfile.rejected]: (state) => {
      state.subscribeToProfileStatus = REJECTED
    },
    // PIN/UNPIN FRIEND REQUEST
    [pinFriend.pending]: (state) => {
      state.pinFriendStatus = PENDING
    },
    [pinFriend.fulfilled]: (state) => {
      state.pinFriendStatus = SUCCEEDED
    },
    [pinFriend.rejected]: (state) => {
      state.pinFriendStatus = REJECTED
    },
    // GET PINNED FRIENDS REQUEST
    [getPinnedFriends.pending]: (state) => {
      state.getPinnedFriendsStatus = PENDING
    },
    [getPinnedFriends.fulfilled]: (state) => {
      state.getPinnedFriendsStatus = SUCCEEDED
    },
    [getPinnedFriends.rejected]: (state) => {
      state.getPinnedFriendsStatus = REJECTED
    },
    // GET ENGAGEMENT ITEMS
    [getEngagementItems.pending]: (state) => {
      state.getEngagementItemsStatus = PENDING
    },
    [getEngagementItems.fulfilled]: (state, action) => {
      state.getEngagementItemsStatus = SUCCEEDED
      const { type } = action.meta.arg

      if (state.engagementItems.length) {
        action.payload.engagementItems.forEach((item) => state.engagementItems.push(item))
      } else {
        state.engagementItems = action.payload.engagementItems
      }

      action.payload.engagementItems.forEach((item) => {
        if (type === 'Likes') {
          if (item.type === 'post') {
            state.lastIdForPost = item.bplId
          } else if (item.type === 'comment') {
            state.lastIdForComment = item.bclId
          }
        }

        if (type === 'Comments') {
          if (item.parent_type === 'post') {
            state.lastIdForPost = item.pcId
          } else if (item.parent_type === 'comment') {
            state.lastIdForComment = item.ccId
          }
        }

        if (type === 'Shares') {
          state.lastIdForEngagement = item.bpsId
        }

        if (type === 'Subscriptions') {
          state.lastIdForEngagement = item.bppId
        }

        if (type === 'Saves') {
          state.lastIdForEngagement = item.sbId
        }
      })
    },
    [getEngagementItems.rejected]: (state) => {
      state.getEngagementItemsStatus = REJECTED
    },
    // PATCH LAST SEEN ENGAGEMENT ITEMS
    [lastSeenEngagement.pending]: (state) => {
      state.lastSeenEngagementStatus = PENDING
    },
    [lastSeenEngagement.fulfilled]: (state) => {
      const engagementType = state.selectedEngagementType.toLowerCase()

      const modified = state.adminNotifications.engagements
        .find((e) => e.type === engagementType)
      modified.newNotifs = 0

      state.adminNotifications.engagements = state.adminNotifications.engagements
        .map((e) => {
          if (e.type === engagementType) {
            return modified
          }

          return e
        })

      state.lastSeenEngagementStatus = SUCCEEDED
    },
    [lastSeenEngagement.rejected]: (state) => {
      state.lastSeenEngagementStatus = REJECTED
    },
    // PATCH SEEN ALL EVENTS
    [eventSeenAll.pending]: (state) => {
      state.eventSeenAllStatus = PENDING
    },
    [eventSeenAll.fulfilled]: (state) => {
      state.adminNotifications.concerts_and_events = state.adminNotifications.concerts_and_events
        .map((item) => {
          if (item?.type === 'real_event') {
            item.is_viewed = 1
          }

          return item
        })

      state.eventSeenAllStatus = SUCCEEDED
    },
    [eventSeenAll.rejected]: (state) => {
      state.getSaved = REJECTED
    },
    // GET SAVED EVENTS
    [getSavedEvents.pending]: (state) => {
      state.getSavedEventsStatus = PENDING
    },
    [getSavedEvents.fulfilled]: (state, action) => {
      if (state.savedEvents.length) {
        action.payload.events.forEach((event) => state.savedEvents.push(event))
      } else {
        state.savedEvents = action.payload.events
      }

      state.getSavedEventsStatus = SUCCEEDED
    },
    [getSavedEvents.rejected]: (state) => {
      state.getSavedEventsStatus = REJECTED
    },
    // SAVE/UNSAVE EVENTS
    [saveEvent.pending]: (state, action) => {
      const payload = action.meta.arg
      state.savedEventId = payload.id

      if (state.notificationSectionPage?.at(-1)?.key === NotificationSections.SAVED_EVENTS_LIST) {
        if (payload.action === 'save') {
          state.savedEvents.unshift({
            id: Math.random() * (9999999 - 9000000 + 1) + Math.floor(Date.now() / 1000),
            eventId: payload.id,
            placeholderOnly: 1
          })
        } else if (payload.action === 'remove') {
          state.savedEvents.some((item) => {
            if (item.eventId === payload.id) {
              item.hide = 1

              return true
            }

            return false
          })
        }
      }

      state.saveEventStatus = PENDING
    },
    [saveEvent.fulfilled]: (state, action) => {
      const payload = action.meta.arg

      if (state.notificationSectionPage?.at(-1)?.key === NotificationSections.SAVED_EVENTS_LIST) {
        if (payload.action === 'save') {
          const eventData = action?.payload?.events[0]

          state.savedEvents = state.savedEvents.map((item) => {
            if (item?.eventId === eventData?.eventId) {
              return eventData
            }

            return item
          })
        } else if (payload.action === 'remove') {
          state.savedEvents = state.savedEvents.filter((item) => item.eventId !== payload.id)
        }
      }

      state.saveEventStatus = SUCCEEDED
    },
    [saveEvent.rejected]: (state, action) => {
      const payload = action.meta.arg
      const errMsg = action?.payload?.message

      if (errMsg === 'The event is unavailable') {
        state.saveEventErrorMsg = errMsg
        state.savedEvents = state.savedEvents.filter((item) => item.eventId !== payload.id)
      } else if (
        state.notificationSectionPage?.at(-1)?.key === NotificationSections.SAVED_EVENTS_LIST
      ) {
        if (payload.action === 'save') {
          state.savedEvents = state.savedEvents.filter((item) => item.eventId !== payload.id)
        } else if (payload.action === 'remove') {
          state.savedEvents.some((item) => {
            if (item.eventId === payload.id) {
              item.hide = 0

              return true
            }

            return false
          })
        }
      }

      state.saveEventStatus = REJECTED
    },
    // GET CRYPTO BALANCE
    [getCryptoBalance.pending]: (state) => {
      state.getCryptoBalanceStatus = PENDING
    },
    [getCryptoBalance.fulfilled]: (state, action) => {
      state.getCryptoBalanceStatus = SUCCEEDED

      state.cryptoBalance = action.payload
    },
    [getCryptoBalance.rejected]: (state) => {
      state.getCryptoBalanceStatus = REJECTED
    },
    // GET EVENT COMMENTS
    [getEventComments.pending]: (state) => {
      state.getEventCommentsStatus = PENDING
    },
    [getEventComments.fulfilled]: (state, action) => {
      state.getEventCommentsStatus = SUCCEEDED
      const payload = action.meta.arg

      if (!payload?.lastItemId) {
        state.eventComments = []
      }

      action.payload.comments.forEach((newEC) => {
        const exists = state.eventComments.some((ec) => ec.id === newEC.id)

        if (!exists) {
          state.eventComments.push(newEC)
        }
      })
    },
    [getEventComments.rejected]: (state) => {
      state.getEventCommentsStatus = REJECTED
    },
    // POST EVENT COMMENT
    [postEventComment.pending]: (state) => {
      state.postEventCommentStatus = PENDING
    },
    [postEventComment.fulfilled]: (state, action) => {
      state.postEventCommentStatus = SUCCEEDED

      state.eventComments.unshift(action.payload.comment)
    },
    [postEventComment.rejected]: (state) => {
      state.postEventCommentStatus = REJECTED
    },
    // PUT EVENT COMMENT
    [putEventComment.pending]: (state) => {
      state.putEventCommentStatus = PENDING
    },
    [putEventComment.fulfilled]: (state, action) => {
      state.putEventCommentStatus = SUCCEEDED
      const commentData = action.payload.comment

      state.eventComments = state.eventComments.map((ec) => {
        const isUpdated = ec?.id === commentData?.id
        return isUpdated ? commentData : ec
      })
    },
    [putEventComment.rejected]: (state) => {
      state.putEventCommentStatus = REJECTED
    },
    // LIKE EVENT COMMENT REQUEST
    [likeEventComment.pending]: (state, action) => {
      state.likeEventCommentStatus = PENDING
      const eventCommentId = action.meta.arg

      state.eventComments.some((ec) => {
        if (ec.id === eventCommentId) {
          if (ec.likedByMe) {
            ec.likes -= 1
            ec.likedByMe = 0
          } else {
            ec.likes += 1
            ec.likedByMe = 1
          }

          return true
        }
        return false
      })
    },
    [likeEventComment.fulfilled]: (state, action) => {
      state.likeEventCommentStatus = SUCCEEDED
      const data = action.payload

      state.eventComments.some((ec) => {
        if (ec.id === data.id) {
          ec.likes = data.likesCount
          ec.likedByMe = data.action === 'like' ? 1 : 0
          ec.likeOngoing = 0

          return true
        }
        return false
      })
    },
    [likeEventComment.rejected]: (state, action) => {
      state.likeEventCommentStatus = REJECTED
      const eventCommentId = action.meta.arg

      state.eventComments.some((ec) => {
        if (ec.id === eventCommentId) {
          ec.likeOngoing = 0

          if (ec.likedByMe) {
            ec.likes -= 1
            ec.likedByMe = 0
          } else {
            ec.likes += 1
            ec.likedByMe = 1
          }

          return true
        }
        return false
      })
    },
    // POST SEEN VIDEO LINK NOTICE
    [seenVideoLinkNotice.pending]: (state) => {
      state.seenVideoLinkNoticeStatus = PENDING
    },
    [seenVideoLinkNotice.fulfilled]: (state, action) => {
      state.seenVideoLinkNoticeStatus = SUCCEEDED

      state.userProfile.some((up) => {
        if (up.id === action.meta.arg) {
          up.has_seen_video_link_notice = true
          return true
        }

        return false
      })
    },
    [seenVideoLinkNotice.rejected]: (state) => {
      state.seenVideoLinkNoticeStatus = REJECTED
    },
    // GET BLOG NOTIFS
    [blogNotifsCount.pending]: (state) => {
      state.blogNotifsCountStatus = PENDING
    },
    [blogNotifsCount.fulfilled]: (state, action) => {
      state.blogNotifsCountStatus = SUCCEEDED

      action.payload.blogNotifsCount.forEach((bnc) => {
        const communityBlog = state.adminNotifications.community_blogs
          .find(
            (cb) => cb?.id === bnc?.id
              || (
                cb?.type === 'all'
                && cb?.type === bnc?.type
              )
              || (
                cb?.type === 'friends'
                && cb?.type === bnc?.type
              )
          )

        if (communityBlog) {
          communityBlog.new_post_count = bnc.new_post_count
        }
      })
    },
    [blogNotifsCount.rejected]: (state) => {
      state.blogNotifsCountStatus = REJECTED
    }
  }
})

export const {
  clearUser,
  setFilters,
  deleteFilter,
  setUserPosition,
  handleOpenModal,
  setProfileItemId,
  deleteProfileItem,
  setUserSectionPage,
  setNotificationSectionPage,
  setChatSectionPage,
  isCloseModal,
  handleCloseModal,
  setIsProfileChanged,
  setIsPictureUploaded,
  setCroppedPicture,
  setCropFor,
  setCloseResetProfileModal,
  setIsProfileActive,
  setIsProfileIncomplete,
  setIsChangesSaved,
  setIsSettingPage,
  setIsLocationOpen,
  setUserEdited,
  setIsProfileDeleted,
  clearNotifs,
  setAdminNotifRequest,
  setIsProfileSwitched,
  setPingStatus,
  clearTestData,
  setPosts,
  setPostsTypeStatus,
  setOnPostEditor,
  setPostPostsApiMsg,
  setExecAutoArchive,
  setComments,
  setBlogParent,
  setOpenPopupBlogs,
  setChosenNotifBlog,
  setResTime1,
  setResTime2,
  setResTime3,
  setResTime4,
  setSelectedUserProfile,
  setRandomPos,
  setAskForLocationServices,
  setGetBlogPreferenceStatus,
  setClosePane,
  setHideNotification,
  setGetPostsStatus,
  setOpenChatModal,
  setCloseChatModal,
  setSharingToFriends,
  setChosenFriends,
  setBlogLinkToBeCopied,
  setHideChat,
  setMsgInputForBlogSharing,
  setHideDrawerAnimation,
  setIsBlogFormOpen,
  setOpenBlogForm,
  setCloseAllDrawers,
  modifyAdminNotifications,
  setMarkerOpenBeforeLogin,
  setOpenFriendRequest,
  setAddFriendStatus,
  setRemoveFriendRequestStatus,
  setDeleteFriendStatus,
  setGetProfileItemStatus,
  setUpdateUserSettingsStatus,
  setGetEngagementItemsStatus,
  setSelectedEngagementType,
  setFromEngagementPanel,
  setEngagementItems,
  setBlogLikeOngoing,
  setBlogSaveOngoing,
  setChosenBlogIndex,
  resetEngagementNewNotifs,
  setRepostThisPostData,
  setPostPostsStatus,
  setPutPostsStatus,
  setBlogRepostData,
  setBlogRepostParent,
  setNewPostsOption,
  setGetSavedEventsStatus,
  setSavedEvents,
  setOpenPopupEvents,
  setSaveEventStatus,
  setDeletePostsStatus,
  setSilentPostId,
  setUpdateUserProfileStatus,
  setConnReqData,
  setAcceptFriendStatus,
  setArchiveRequestStatus,
  setDenyFriendStatus,
  setCryptoBalance,
  setOpenBlogLink,
  setEventCommentLikeOngoing,
  setEventComments,
  setEventCommentTree
} = users.actions

export default users.reducer
